import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useAppContext } from '../../context/AppContext';
import { LandingTrans, SocialHubTrans } from '../../utils/translations';
import { trackPixelEvent } from '../../utils/pixel';
import '../../styles/socialHub.css';
import AvatarPhoto from '../../assets/photos/anya-avatar.jpg';

const WHATSAPP_URL = 'https://wa.me/972559116975';

/** Icon-only marks (no wordmarks) on brand-colored circles */
function IconFacebook() {
  return (
    <svg className="social-hub__glyph" viewBox="0 0 24 24" width="22" height="22" aria-hidden>
      <path
        fill="currentColor"
        d="M13.35 22v-8.42h2.82l.42-3.28h-3.24V8.62c0-.95.26-1.6 1.62-1.6h1.73V3.9h-2.76c-2.74 0-3.66 1.62-3.66 4.34v2.06H7.2v3.28h2.87V22h3.28z"
      />
    </svg>
  );
}

function IconYouTube() {
  return (
    <svg className="social-hub__glyph" viewBox="0 0 24 24" width="24" height="24" aria-hidden>
      <rect
        x="3.35"
        y="6.85"
        width="17.3"
        height="10.3"
        rx="2.85"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
      />
      <path fill="currentColor" d="M10.15 9.9v4.2l3.85-2.1-3.85-2.1z" />
    </svg>
  );
}

function IconInstagram() {
  return (
    <svg className="social-hub__glyph" viewBox="0 0 24 24" width="22" height="22" aria-hidden>
      <path
        fill="currentColor"
        d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"
      />
    </svg>
  );
}

function IconWhatsApp() {
  return (
    <svg className="social-hub__glyph" viewBox="0 0 24 24" width="22" height="22" aria-hidden>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"
      />
    </svg>
  );
}

function SectionHead({ id, title }) {
  return (
    <div className="social-hub__section-head">
      <span className="social-hub__rule" aria-hidden />
      <h2 id={id} className="social-hub__section-heading">
        {title}
      </h2>
      <span className="social-hub__rule" aria-hidden />
    </div>
  );
}

export default function SocialHub() {
  const { language } = useAppContext();
  const landing = LandingTrans[language] || LandingTrans.english;
  const hubLabels = SocialHubTrans[language] || SocialHubTrans.english;
  const hubTitle =
    language === 'russian' && landing.uponamat
      ? `${landing.once} ${landing.uponamat}`
      : landing.once;

  const sections = [
    {
      id: 'practice',
      title: hubLabels.practiceSectionTitle,
      links: [
        {
          to: '/onlineClub',
          label: hubLabels.onlineClubTitle,
          desc: hubLabels.onlineClubDesc,
          price: hubLabels.onlineClubPrice,
          pixel: 'SocialHubOnlineClub',
        },
        {
          to: '/individual',
          label: hubLabels.individual,
          desc: hubLabels.individualDesc,
          price: hubLabels.individualPrice,
          pixel: 'SocialHubIndividual',
        },
      ],
    },
    {
      id: 'business',
      title: hubLabels.businessSectionTitle,
      links: [
        {
          href: 'https://tends.me',
          label: hubLabels.tendsLink,
          desc: hubLabels.tendsDesc,
          price: hubLabels.tendsPrice,
          pixel: 'SocialHubTends',
        },
      ],
    },
  ];

  const instagramHref =
    language === 'russian'
      ? 'https://www.instagram.com/joykayoga/'
      : 'https://www.instagram.com/once.up.on.a.mat';

  const socials = [
    {
      href: 'https://www.facebook.com/theanyajoy',
      label: 'Facebook',
      pixel: 'SocialHubFacebook',
      brand: 'facebook',
      Icon: IconFacebook,
    },
    {
      href: instagramHref,
      label: 'Instagram',
      pixel: 'SocialHubInstagram',
      brand: 'instagram',
      Icon: IconInstagram,
    },
    {
      href: 'https://www.youtube.com/@once-up-on-a-mat',
      label: 'YouTube',
      pixel: 'SocialHubYouTube',
      brand: 'youtube',
      Icon: IconYouTube,
    },
    {
      href: WHATSAPP_URL,
      label: 'WhatsApp',
      pixel: 'SocialHubWhatsApp',
      brand: 'whatsapp',
      Icon: IconWhatsApp,
    },
  ];

  const handleNav = (pixel) => {
    trackPixelEvent(pixel);
  };

  return (
    <main className="social-hub">
      <Helmet>
        <title>{hubTitle} — links</title>
        <meta name="description" content={landing.description} />
      </Helmet>
      <div className="social-hub__inner">
        <div className="social-hub__card">
          <div className="social-hub__avatar">
            <img src={AvatarPhoto} alt={hubLabels.greeting} className="social-hub__avatar-img" />
          </div>
          <p className="social-hub__brand">{hubTitle}</p>
          <h1 className="social-hub__greeting">{hubLabels.greeting}</h1>
          <p className="social-hub__tagline">{hubLabels.tagline}</p>

          {sections.map(({ id, title, links }) => (
            <section
              key={id}
              className="social-hub__section"
              aria-labelledby={`social-hub-${id}-heading`}
            >
              <SectionHead id={`social-hub-${id}-heading`} title={title} />
              <ul className="social-hub__list">
                {links.map(({ to, href, label, desc, price, pixel }) => {
                  const content = (
                    <>
                      <span className="social-hub__card-title">{label}</span>
                      <span className="social-hub__card-arrow" aria-hidden>
                        ↗
                      </span>
                      {desc && <span className="social-hub__card-desc">{desc}</span>}
                      {price && <span className="social-hub__card-price">{price}</span>}
                    </>
                  );
                  return (
                    <li key={to || href}>
                      {href ? (
                        <a
                          href={href}
                          className="social-hub__link social-hub__link--card"
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={() => handleNav(pixel)}
                        >
                          {content}
                        </a>
                      ) : (
                        <Link
                          to={to}
                          className="social-hub__link social-hub__link--card"
                          onClick={() => handleNav(pixel)}
                        >
                          {content}
                        </Link>
                      )}
                    </li>
                  );
                })}
              </ul>
            </section>
          ))}

          <section
            className="social-hub__section"
            aria-labelledby="social-hub-secondary-heading"
          >
            <SectionHead
              id="social-hub-secondary-heading"
              title={hubLabels.secondarySectionTitle}
            />
            <div className="social-hub__row">
              <Link
                to="/profile"
                className="social-hub__link social-hub__link--small"
                onClick={() => handleNav('SocialHubCabinet')}
              >
                {hubLabels.cabinetCta}
              </Link>
              <Link
                to="/schedule"
                className="social-hub__link social-hub__link--small"
                onClick={() => handleNav('SocialHubSchedule')}
              >
                {hubLabels.scheduleCta}
              </Link>
            </div>
          </section>

          <nav className="social-hub__socials" aria-label="Social media">
            {socials.map(({ href, label, pixel, brand, Icon }) => (
              <a
                key={label}
                href={href}
                className={`social-hub__social-circle social-hub__social-circle--${brand}`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                onClick={() => handleNav(pixel)}
              >
                <Icon />
              </a>
            ))}
          </nav>
        </div>
      </div>
    </main>
  );
}
